<template>
  <div class="dashboard-layout">
    <SideMenu class="sidemenu"></SideMenu>
    <div class="dashboard-content">
      <button @click="toggleSideMenu" class="mobile-menu-toggle is-hidden-tablet">
        <i class="fas fa-bars"></i>
      </button>
      <div class="content-wrapper">
        <router-view name="dashboardContent"></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import SideMenu from '../components/SideMenu'

export default {
  name: "Dashboard",
  components: {
    SideMenu
  },
  methods: {
    toggleSideMenu() {
      this.$store.commit('toggleMenu');
    }
  }
}
</script>

<style scoped>
.dashboard-layout {
  height: 100vh;
  display: flex;
}

@media only screen and (min-width: 769px) {
  .dashboard-layout {
    display: grid;
    grid-template-columns: var(--sidebar-width) 1fr;
  }
}

.dashboard-content {
  background: var(--background);
  overflow-y: auto;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.mobile-menu-toggle {
  position: fixed;
  top: 16px;
  left: 16px;
  z-index: 50;
  background: var(--surface);
  border: 1px solid #E2E8F0;
  border-radius: var(--radius-md);
  padding: 12px 16px;
  cursor: pointer;
  box-shadow: var(--shadow-sm);
  transition: all var(--transition-base);
}

.mobile-menu-toggle:hover {
  background: var(--surface-elevated);
  box-shadow: var(--shadow-md);
}

.mobile-menu-toggle i {
  font-size: 1.25rem;
  color: var(--text-primary);
}

.content-wrapper {
  flex: 1;
  padding: 32px;
}

@media only screen and (max-width: 768px) {
  .content-wrapper {
    padding: 24px 16px;
    padding-top: 72px;
  }
}
</style>
